import { get } from 'api/api';
import getIdExchangeUrl from 'api/listing/getExchangeUrl';
import useSWR from 'swr';

export interface IdExchangeResponse {
  data: string[];
}

const fetchExchangeIds = async (
  experienceIds: string[],
  brandId: string,
): Promise<string[]> => {
  try {
    const results = await Promise.all(
      experienceIds.map(async (id) => {
        const url = getIdExchangeUrl(id);
        const data: IdExchangeResponse = await get(url, {
          headers: {
            'Kouto-Brand-Id': brandId,
            'Way-Brand-Id': brandId,
          },
        });
        return data.data;
      }),
    );
    return results.flat();
  } catch (error) {
    console.error('Error fetching exchange IDs:', error);
    return [];
  }
};

const useExchangeId = (
  experienceIds?: string | string[] | null,
  brandId?: string,
) => {
  const idsArray = (
    Array.isArray(experienceIds) ? experienceIds : [experienceIds]
  ).filter(Boolean) as string[];

  const shouldSkip = !brandId || idsArray.length === 0;

  const { data, error, isLoading } = useSWR(
    shouldSkip ? null : [idsArray, brandId],
    ([idsArray, brandId]) => fetchExchangeIds(idsArray, brandId),
  );

  if (error) {
    console.error('Error fetching exchange IDs:', error);
  }

  return { data, error, isLoading };
};

export default useExchangeId;
